import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function TempoTravellerOnRentMumbai() {



    const cardData = {





keyword: "Tempo Traveller On Rent Mumbai",

headingDescription: "Shreesha Tours & Travels provides reliable and affordable Tempo Traveller on Rent in Mumbai for family vacations, group tours, corporate travel, destination weddings, pilgrimage tours, school and college trips, airport transfers, sightseeing, business events, and outstation journeys across India. Our fleet includes 9 Seater, 12 Seater, 15 Seater, 17 Seater, 20 Seater, Maharaja Tempo Traveller, Luxury Tempo Traveller, Urbania, and Force Traveller vehicles equipped with comfortable pushback seats, spacious interiors, air conditioning, ample luggage space, music system, charging points, and experienced chauffeurs. Whether you are planning a weekend getaway, religious tour, office outing, group excursion, or multi-day holiday, our Tempo Traveller rental service offers a safe, comfortable, and enjoyable travel experience. With transparent pricing, flexible itineraries, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and 24/7 customer support, Shreesha Tours & Travels ensures hassle-free group transportation for every occasion at competitive rates.",

topPlaces: [
  {
    title: "Mumbai to Amboli",
    description: "Amboli is a picturesque hill station in the Sahyadri ranges, famous for waterfalls, misty valleys, sunset points, and lush forests. It is an excellent destination for group picnics and monsoon tours."
  },
  {
    title: "Mumbai to Gokarna",
    description: "Gokarna is a peaceful coastal town known for Om Beach, Kudle Beach, Mahabaleshwar Temple, Paradise Beach, and scenic cliff views. It is a perfect destination for family groups and friends traveling together."
  },
  {
    title: "Mumbai to Murudeshwar",
    description: "Murudeshwar is famous for the world's second tallest Shiva statue, Murudeshwar Temple, beautiful beaches, and water activities. Tempo Travellers are ideal for religious and coastal group tours."
  },
  {
    title: "Mumbai to Udupi",
    description: "Udupi is renowned for Sri Krishna Temple, Malpe Beach, St. Mary's Island, and delicious South Indian cuisine. It is a popular destination for family vacations and pilgrimage groups."
  },
  {
    title: "Mumbai to Coorg",
    description: "Coorg is known for coffee plantations, Abbey Falls, Raja's Seat, Dubare Elephant Camp, and scenic hills. It is one of the best destinations for group holidays and nature lovers."
  },
  {
    title: "Mumbai to Chikmagalur",
    description: "Chikmagalur is a beautiful hill station famous for coffee estates, Mullayanagiri Peak, waterfalls, trekking trails, and breathtaking landscapes. It is an ideal destination for weekend group trips."
  },
  {
    title: "Mumbai to Hampi",
    description: "Hampi, a UNESCO World Heritage Site, is famous for ancient temples, stone monuments, Virupaksha Temple, Vittala Temple, and rich historical architecture. Group travelers often choose Tempo Travellers for comfortable sightseeing."
  },
  {
    title: "Mumbai to Vijayapura",
    description: "Vijayapura is known for Gol Gumbaz, Ibrahim Rauza, historical monuments, and Indo-Islamic architecture. It is a preferred destination for educational tours and heritage trips."
  },
  {
    title: "Mumbai to Akkalkot",
    description: "Akkalkot is a renowned pilgrimage destination dedicated to Shri Swami Samarth Maharaj. Families and devotees frequently hire Tempo Travellers for comfortable spiritual journeys."
  },
  {
    title: "Mumbai to Sindhudurg",
    description: "Sindhudurg is famous for Sindhudurg Fort, Tarkarli Beach, scuba diving, snorkeling, and pristine Konkan coastline. It is an excellent destination for family vacations, beach holidays, and group tours."
  }
],



"services": [
  {
    "name": "Tempo Traveller On Rent Mumbai",
    "description": "Book Tempo Traveller On Rent Mumbai for safe, comfortable, and spacious group travel with professional chauffeurs and well-maintained AC vehicles. Our Tempo Travellers are ideal for family vacations, corporate events, wedding transportation, school trips, religious tours, airport transfers, sightseeing, and outstation travel. Choose from 12 Seater, 17 Seater, and 20 Seater Tempo Travellers with comfortable seating, ample luggage space, and affordable one way and round trip packages for a hassle-free journey."
  },
  {
    "name": "Tempo Traveller Rental Mumbai",
    "description": "Choose Tempo Traveller Rental Mumbai for reliable and affordable group transportation with clean vehicles, experienced drivers, and flexible rental plans. We provide premium Tempo Travellers suitable for family gatherings, corporate outings, holiday tours, business events, and long-distance travel with convenient pickup and drop services."
  },
  {
    "name": "Tempo Traveller Hire Mumbai",
    "description": "Hire Tempo Traveller Mumbai for comfortable travel with spacious seating, modern interiors, and professional chauffeurs. Our rental service is perfect for weddings, pilgrimage tours, educational trips, airport transfers, sightseeing, and weekend getaways across Maharashtra and India."
  },
  {
    "name": "Mumbai Tempo Traveller Booking",
    "description": "Complete Mumbai Tempo Traveller Booking online with instant confirmation, transparent pricing, and multiple seating options. Select the ideal Tempo Traveller according to your group size and enjoy safe, comfortable, and reliable transportation with doorstep pickup."
  },
  {
    "name": "Tempo Traveller Cab Service Mumbai",
    "description": "Book Tempo Traveller Cab Service Mumbai for smooth and dependable group travel with trained chauffeurs, comfortable seating, and fully air-conditioned vehicles. Perfect for corporate travel, family vacations, destination weddings, and outstation tours with flexible booking options."
  },
  {
    "name": "Tempo Traveller with Driver Mumbai",
    "description": "Choose Tempo Traveller with Driver Mumbai for stress-free travel with experienced, courteous chauffeurs who ensure a safe and enjoyable journey. Ideal for long-distance travel, sightseeing tours, airport transfers, business trips, and family outings."
  },
  {
    "name": "Tempo Traveller Outstation Mumbai",
    "description": "Hire Tempo Traveller Outstation Mumbai for convenient interstate and intercity travel with spacious vehicles, professional drivers, and affordable packages. Travel comfortably to Goa, Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Gujarat, Karnataka, and other destinations."
  },
  {
    "name": "Tempo Traveller for Family Trip Mumbai",
    "description": "Book Tempo Traveller for Family Trip Mumbai for comfortable vacations with spacious seating, luggage capacity, and safe transportation. Ideal for family holidays, temple visits, hill station tours, beach vacations, and weekend getaways."
  },
  {
    "name": "Tempo Traveller for Group Tour Mumbai",
    "description": "Choose Tempo Traveller for Group Tour Mumbai for convenient travel with friends, office teams, schools, colleges, and tour groups. Enjoy comfortable seating, professional drivers, and flexible travel schedules for memorable journeys."
  },
  {
    "name": "Tempo Traveller Airport Transfer Mumbai",
    "description": "Book Tempo Traveller Airport Transfer Mumbai for timely airport pickup and drop services with spacious luggage capacity and professional chauffeurs. Enjoy reliable transfers to and from Mumbai International Airport for families, corporate groups, and tourists."
  },
  {
    "name": "Tempo Traveller 12 Seater Mumbai",
    "description": "Reserve Tempo Traveller 12 Seater Mumbai for medium-sized groups seeking comfortable travel with modern interiors, AC comfort, and professional drivers. Suitable for family tours, airport transfers, and business travel."
  },
  {
    "name": "Tempo Traveller 17 Seater Mumbai",
    "description": "Book Tempo Traveller 17 Seater Mumbai for larger family trips, corporate outings, educational tours, and group sightseeing. Enjoy spacious seating, comfortable interiors, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Tempo Traveller 20 Seater Mumbai",
    "description": "Choose Tempo Traveller 20 Seater Mumbai for large group travel with comfortable seating, ample luggage space, and experienced chauffeurs. Perfect for weddings, school excursions, religious tours, corporate events, and long-distance journeys."
  },
  {
    "name": "Luxury Tempo Traveller Mumbai",
    "description": "Hire Luxury Tempo Traveller Mumbai with premium interiors, pushback seats, air conditioning, entertainment features, and professional chauffeurs. Enjoy luxurious travel for weddings, VIP transportation, corporate travel, and premium family vacations."
  },
  {
    "name": "Best Tempo Traveller Rental Mumbai",
    "description": "Choose the Best Tempo Traveller Rental Mumbai for dependable service, well-maintained vehicles, experienced drivers, transparent pricing, and exceptional customer support. Enjoy comfortable group transportation with flexible booking options for local, airport, and outstation travel."
  }
],
"tableData": [
  ["Tempo Traveller On Rent Mumbai", "Tempo Traveller Rental Mumbai"],
  ["Tempo Traveller Hire Mumbai", "Mumbai Tempo Traveller Booking"],
  ["Tempo Traveller Cab Service Mumbai", "Tempo Traveller with Driver Mumbai"],
  ["Tempo Traveller Outstation Mumbai", "Tempo Traveller for Family Trip Mumbai"],
  ["Tempo Traveller for Group Tour Mumbai", "Tempo Traveller Airport Transfer Mumbai"],
  ["Tempo Traveller 12 Seater Mumbai", "Tempo Traveller 17 Seater Mumbai"],
  ["Tempo Traveller 20 Seater Mumbai", "Luxury Tempo Traveller Mumbai"],
  ["Best Tempo Traveller Rental Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Tempo Traveller on Rent in Mumbai",
    WhyChoosedescription: "Planning a group journey from Mumbai? Shreesha Travels offers premium Tempo Traveller rental services for family vacations, corporate outings, pilgrimage tours, educational trips, weddings, airport transfers, and outstation travel with spacious, chauffeur-driven vehicles."
  },
  {
    WhyChooseheading: "Ideal for Group Tours & Large Families",
    WhyChoosedescription: "Whether you're travelling with friends, relatives, colleagues, or tour groups, our Tempo Travellers provide generous seating, ample luggage space, and comfortable interiors for a relaxed travel experience."
  },
  {
    WhyChooseheading: "Travel Together Without Splitting Into Multiple Cars",
    WhyChoosedescription: "A single Tempo Traveller keeps everyone together throughout the journey, making it convenient for sightseeing, destination weddings, company events, religious tours, and long-distance road trips."
  },
  {
    WhyChooseheading: "Available for Local, Airport & Outstation Trips",
    WhyChoosedescription: "Book Tempo Travellers for Mumbai city tours, Mumbai Airport transfers, Pune, Lonavala, Mahabaleshwar, Goa, Shirdi, Nashik, Surat, Ahmedabad, Bengaluru, Jaipur, Indore, and destinations across India."
  },
  {
    WhyChooseheading: "Multiple Seating Options for Every Group Size",
    WhyChoosedescription: "Choose from 9, 12, 14, 17, 20, and 26-seater Tempo Travellers, allowing you to select the perfect vehicle based on your passenger count and travel requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
    WhyChoosedescription: "Our trained chauffeurs are experienced in handling group travel, highway routes, hill stations, pilgrimage circuits, and multi-day tours while maintaining a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Clean, Spacious & Well-Maintained Vehicles",
    WhyChoosedescription: "Every Tempo Traveller is regularly serviced, sanitized, air-conditioned, and inspected before departure, ensuring passengers enjoy a reliable and comfortable travel experience."
  },
  {
    WhyChooseheading: "Book Group Travel with Shreesha Travels",
    WhyChoosedescription: "From weekend getaways to extended tours, Shreesha Travels delivers dependable Tempo Traveller rentals with transparent pricing, flexible travel plans, and professional customer support."
  }
]

};

const faqData = [
  {
    question: "What seating capacities are available in your Tempo Travellers?",
    answer: "We offer 9, 12, 14, 17, 20, and 26-seater Tempo Travellers to accommodate different group sizes."
  },
  {
    question: "Is a Tempo Traveller suitable for outstation road trips?",
    answer: "Yes, Tempo Travellers are ideal for long-distance travel, offering comfortable seating, luggage space, and a smooth journey for groups."
  },
  {
    question: "Can I hire a Tempo Traveller for a wedding or family function?",
    answer: "Yes, our vehicles are frequently booked for weddings, receptions, engagements, family gatherings, and guest transportation."
  },
  {
    question: "Do you provide Tempo Travellers for corporate outings?",
    answer: "Yes, companies regularly book our Tempo Travellers for team outings, conferences, employee transportation, and corporate events."
  },
  {
    question: "Are Mumbai Airport group transfers available?",
    answer: "Yes, we provide Tempo Traveller services for airport pickups and drops for families, tourists, business delegates, and large groups."
  },
  {
    question: "Can I reserve a Tempo Traveller for multi-day tours?",
    answer: "Yes, customized packages are available for multi-day vacations, pilgrimage tours, educational excursions, and sightseeing trips."
  },
  {
    question: "Do all Tempo Travellers include a professional driver?",
    answer: "Yes, every booking includes an experienced chauffeur to ensure safe, comfortable, and hassle-free travel."
  },
  {
    question: "How is the Tempo Traveller rental fare calculated?",
    answer: "The fare depends on the seating capacity, travel distance, number of travel days, destination, route, and any additional travel requirements."
  },
  {
    question: "Can I customize my travel itinerary?",
    answer: "Yes, you can include multiple destinations, sightseeing stops, overnight stays, and personalized travel schedules."
  },
  {
    question: "How can I book a Tempo Traveller on Rent in Mumbai with Shreesha Travels?",
    answer: "Simply share your travel dates, pickup location, destination, group size, preferred seating capacity, and itinerary to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Bhosale",
    feedback: "Managing a large group became incredibly easy thanks to the spacious Tempo Traveller and well-organized travel arrangements. The journey remained comfortable from departure to arrival.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Narayanan",
    feedback: "Everyone in our group appreciated the roomy seating, smooth ride, and professional service. The vehicle was perfectly suited for a long-distance tour and made the entire experience enjoyable.",
    rating: 5
  }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/tempo-traveller-on-rent-mumbai.webp",
  "description":
    "Book Tempo Traveller On Rent Mumbai with Shreesha Tours & Travels for comfortable and spacious group travel solutions. We provide well-maintained Tempo Travellers with driver available 24x7 for family trips, group tours, corporate outings, pilgrimage tours, airport transfers, weddings, sightseeing, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/tempo-traveller-on-rent-mumbai"
  }
};






    return (
        <div>
<Helmet>
  <title>Tempo Traveller On Rent Mumbai | Group Travel Vehicle | +91 8355835813</title>

  <meta
    name="description"
    content="Book Tempo Traveller On Rent Mumbai with Shreesha Travels for group tours, family trips, corporate outings, and outstation travel. Hire comfortable Tempo Traveller with driver for airport transfers, sightseeing, and long-distance journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Tempo Traveller On Rent Mumbai, Tempo Traveller Rental Mumbai, Tempo Traveller Hire Mumbai, Mumbai Tempo Traveller Booking, Tempo Traveller Cab Service Mumbai, Tempo Traveller with Driver Mumbai, Tempo Traveller Outstation Mumbai, Tempo Traveller for Family Trip Mumbai, Tempo Traveller for Group Tour Mumbai, Tempo Traveller Airport Transfer Mumbai, 12 Seater Tempo Traveller Mumbai, 17 Seater Tempo Traveller Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default TempoTravellerOnRentMumbai;